module.exports = __webpack_public_path__ + "img/3.61d0bd75.png";